import * as frappeSDK from "frappe-react-sdk";
const _f = (frappeSDK as any).default || frappeSDK;
const { useFrappeGetCall } = _f as Pick<typeof frappeSDK, "useFrappeGetCall">;

export interface HeaderSettings {
  brand_name: string;
  brand_subtitle: string;
  book_btn_label: string;
}

export interface HeroSlide {
  image: string;
  title: string;
  eyebrow: string;
  description: string;
  primary_cta_label: string;
  primary_cta_icon: string;
  primary_cta_link: string;
  secondary_cta_label: string;
  secondary_cta_icon: string;
  secondary_cta_link: string;
  badges: string[];
}

export interface HeroSettings {
  slides: HeroSlide[];
}

export interface StatItem {
  value: string;
  label: string;
}

export interface StatsSettings {
  items: StatItem[];
}

export interface QuickAccessItem {
  icon: string;
  title: string;
  description: string;
  link: string;
}

export interface QuickAccessSettings {
  heading: string;
  subtitle: string;
  description: string;
  items: QuickAccessItem[];
}

export interface DepartmentsSettings {
  heading: string;
  subtitle: string;
  description: string;
  stats: StatItem[];
}

export interface FounderSettings {
  heading: string;
  title: string;
  message: string;
  author_name: string;
  author_title: string;
  established_year: string;
  location: string;
}

export interface DoctorsSettings {
  heading: string;
  title: string;
  cta_label: string;
  cta_link: string;
}

export interface PackagesSettings {
  heading: string;
  title: string;
  description: string;
  most_popular_label: string;
}

export interface FacilitiesSettings {
  heading: string;
  title: string;
  description: string;
  cta_label: string;
}

export interface HomeSettings {
  header: HeaderSettings;
  hero: HeroSettings;
  stats: StatsSettings;
  quick_access: QuickAccessSettings;
  departments: DepartmentsSettings;
  founder: FounderSettings;
  doctors: DoctorsSettings;
  packages: PackagesSettings;
  facilities: FacilitiesSettings;
}

export const useHomeSettings = () => {
  const { data, isLoading, error } = useFrappeGetCall<{ message: HomeSettings }>(
    "health_web.api.home.get_home_settings",
    undefined,
    "home_settings",
  );

  return {
    settings: data?.message ?? null,
    isLoading,
    error,
  };
};
